import { baseApi } from "@/redux/api/baseApi";

const assignmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitAssignment: builder.mutation({
      query: (payload) => ({
        url: "/creatorAssignment/submit",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["User","creatorStatus"],
    }),
    getAssignmentDeadline: builder.query({
      query: (email) => ({
        url: `/creatorAssignment/get-assignment-deadline?email=${email}`,
        method: "Get",
      }),
    }),
  }),
});

export const { useSubmitAssignmentMutation,useGetAssignmentDeadlineQuery } = assignmentApi;
